module.exports = __webpack_public_path__ + "assets/img/00192.8e215fcc.png";